import { useRef as i, useEffect as o } from "react";
function s(n, r, c) {
  return Object.freeze({
    instance: n,
    context: r,
    container: c
  });
}
function b(n, r) {
  return r == null ? function(e, u) {
    const t = i();
    return t.current || (t.current = n(e, u)), t;
  } : function(e, u) {
    const t = i();
    t.current || (t.current = n(e, u));
    const f = i(e), { instance: l } = t.current;
    return o(function() {
      f.current !== e && (r(l, e, f.current), f.current = e);
    }, [
      l,
      e,
      u
    ]), t;
  };
}
export {
  b as createElementHook,
  s as createElementObject
};
